<div class="palette">
  <p class="palette-subtitle">{{ 'policyBuilder.palette.subtitle' | transloco }}</p>

  <div class="palette-grid">
    @for (cat of categories(); track cat.id) {
      <div class="palette-section" [attr.data-category]="cat.id">
        <span class="palette-section-label">
          <mat-icon class="palette-section-icon">{{ cat.icon }}</mat-icon>
          {{ cat.labelKey | transloco }}
        </span>

        <div class="palette-chips">
          @for (opt of cat.types; track opt.type) {
            <button class="palette-chip"
                    [class.palette-chip--disabled]="isDisabled(opt.type)"
                    [disabled]="isDisabled(opt.type)"
                    (click)="select(opt.type)"
                    [attr.aria-label]="opt.labelKey | transloco">
              <mat-icon class="palette-chip-icon">{{ opt.icon }}</mat-icon>
              <span class="palette-chip-label">{{ opt.labelKey | transloco }}</span>
              <mat-icon class="palette-chip-add">add</mat-icon>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
